import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { CLASS_ACTION_EVENT_TABS } from "src/constants/tabs";
import { useClassActionEventQuery } from "src/store/classActionEvent";

export function ClassActionEvent() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const {
    data: classActionEvent,
    isLoading,
    error,
  } = useClassActionEventQuery({ id });
  const match = useMatch(`/classAction-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/class-action-events/${id}/${value}`);
  };

  if (error || (!isLoading && !classActionEvent)) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Class Action Events"
        to={`/class-action-events?view=${
          classActionEvent?.operationsStatus === "approved"
            ? "approved"
            : "upcoming"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/class-action-events/${id}/details`}
          issuerName={classActionEvent.issuer.name || "-"}
          issuerId={classActionEvent.issuer?.id}
          type="Class action"
          subHeader={
            classActionEvent.jobNumber
              ? `${classActionEvent.claimsAdministrator.name} - ${classActionEvent.jobNumber}`
              : classActionEvent.claimsAdministrator.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={CLASS_ACTION_EVENT_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
